import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/face.png'
import _imports_1 from '@/assets/face1.png'


const _withScopeId = n => (_pushScopeId("data-v-d1a99c52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "face" }
const _hoisted_2 = {
  key: 0,
  class: "face-loading"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "face-spinner" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "face-loading-txt" }, "请稍候", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "face-loading-tip" }, "正在跳转中...", -1))
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "face-icon",
  src: _imports_0
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "face-txt" }, "已完成人脸识别", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "face-icon",
  src: _imports_1
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "face-txt" }, [
  /*#__PURE__*/_createTextVNode("因未授权摄像头"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 请您直接进入医生视频完成身份验证")
], -1))

import { computed, defineComponent, getCurrentInstance,watch, nextTick, onMounted, reactive, toRefs, ref } from 'vue';
    import tabbar from "src/components/common/tabbar";
    import JSEncryptUtils from 'utils/encrypt-utils';
    import dayjs from 'dayjs';
    import { AuthService } from 'src/services';
    import {useToken } from 'src/store';
    import { useRouter, useRoute } from 'vue-router';
    import patterns from "src/utils/patterns";
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const router = useRouter();
    const route = useRoute();
    let similarity = ref(0);
    let taskId = ref(null);
    let faceVerifyType = ref(1);
    let showFace = ref(false);
    let isAuthorization= ref(true);

   // 人脸验证
   const faceVerifyLogin = async () : Promise<void> =>
    {
        try
        {
            let {content: reslut} = await AuthService.instance.faceVerifyLogin({
                taskId: taskId.value,
                url: encodeURIComponent(`${location.origin}/face/verify?type=${faceVerifyType.value}&id=${taskId.value}`),
                faceVerifyType: faceVerifyType.value
            });
            
            location.href = reslut.data;
            
        }
        catch(err)
        {
           // 成功
           if(faceVerifyType.value == 1)
            {
                // 问卷呼叫
                onGoCall();
            }
            else
            {
                // 补签名
                router.replace({name: "countersign", query:{id: taskId.value + ''}});
            }
        }
    }

    let loadingResult = ref(false);

    // 单次查询人脸核审结果，拿到结果返回 true，否则返回 false
    const querytFaceVerify = async (orderNo) : Promise<boolean> =>
    {
        try
        {
            let {content: reslut} = await AuthService.instance.selectFaceVerify(orderNo);

            // 后端无论结果是否就绪都返回非空对象，未拿到腾讯结果时
            // bizSeqNo 为空、similarity/liveRate 为 0，因此以 bizSeqNo
            // 是否落值（或 similarity 大于 0）作为"结果已就绪"的判定
            let data = reslut && reslut.data;
            if(data && (data.bizSeqNo || Number(data.similarity) > 0))
            {
                similarity.value = data.similarity || 0;
                showFace.value = true;
                return true;
            }
        }
        catch(err)
        {
            // 腾讯结果可能尚未落库，吞掉错误继续轮询，最终超时再提示
            console.log(err);
        }
        return false;
    }

    // 轮询查询人脸核审结果，兜住腾讯人脸核身结果落库的短暂延迟。
    // 每次请求有 2.5 秒超时；最多等待约 8.5 秒，超时后不再阻塞腾讯回调的后续跳转。
    const selectFaceVerify = async (orderNo, maxRetry = 3, interval = 500) : Promise<boolean> =>
    {
        loadingResult.value = true;
        try
        {
            for(let i = 0; i < maxRetry; i++)
            {
                if(await querytFaceVerify(orderNo))
                {
                    return true;
                }
                // 最后一次不再等待
                if(i < maxRetry - 1)
                {
                    await new Promise(resolve => setTimeout(resolve, interval));
                }
            }
            return false;
        }
        finally
        {
            loadingResult.value = false;
        }
    }

    onMounted(()=>
    {
        // if(route.query.type)
        // {
        //     faceVerifyType.value = +route.query.type;
        // }
        // if(route.query.id)
        // {
        //     taskId.value = +route.query.id;
        // }
        // // code == 0 成功
        // if(route.query.orderNo)
        // {
        //     selectFaceVerify(route.query.orderNo);
        //     if(route.query.code == "0")
        //     {
        //         // 成功
        //         if(faceVerifyType.value == 1)
        //         {
        //             // 问卷呼叫
        //             onGoCall();
        //         }
        //         else
        //         {
        //             // 补签名
        //             router.replace({name: "sign", query:{id: taskId.value + ''}});
        //         }
        //     }
        //     else if(route.query.code == "66660010" || route.query.code== "3004" || route.query.code== "3005")
        //     {
        //         // https://cloud.tencent.com/document/product/1007/61074
        //         // https://cloud.tencent.com/document/product/1007/47912
        //         // 成功
        //         if(faceVerifyType.value == 1)
        //         {
        //             // 问卷呼叫
        //             onGoCall();
        //         }
        //         else
        //         {
        //             // 确认本人
        //             router.replace({name: "countersign", query:{id: taskId.value + ''}});
        //         }
        //     }
        // }
        // else
        // {
        //     faceVerifyLogin();
        // }
    })

    // 跳转呼叫
    const onGoCall =  ()=>
    {
        router.push({name: "calling", query:{id: taskId.value}});
    }

    watch(route, async ()=>
    {
        if(route.query.type)
        {
            faceVerifyType.value = +route.query.type;
        }
        if(route.query.id)
        {
            taskId.value = route.query.id;
        }
        // code == 0 成功
        if(route.query.orderNo)
        {
            // 先轮询等待后端拿到腾讯人脸核身结果，避免结果未入库就跳转视频页
            await selectFaceVerify(route.query.orderNo);
            if(route.query.code == "0")
            {
                // 成功
                if(faceVerifyType.value == 1)
                {
                    // 问卷呼叫
                    onGoCall();
                }
                else
                {
                    // 补签名
                    router.replace({name: "sign", query:{id: taskId.value + ''}});
                }
            }
            else if(route.query.code == "66660010" || route.query.code == "66660004" || route.query.code== "3004" || route.query.code== "3005")
            {
                // https://cloud.tencent.com/document/product/1007/61074
                // https://cloud.tencent.com/document/product/1007/47912
                // 成功
                if(faceVerifyType.value == 1)
                {
                    // 问卷呼叫
                    onGoCall();
                }
                else
                {
                    // 确认本人
                    router.replace({name: "countersign", query:{id: taskId.value + ''}});
                }
            }
        }
        else
        {
            faceVerifyLogin();
        }
    },{immediate: true, deep: true})

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(loadingResult))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_6))
      : (_unref(showFace))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_unref(isAuthorization))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_7,
                  _hoisted_8
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_9,
                  _hoisted_10
                ], 64)),
            (_unref(faceVerifyType) ==1)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn-primary",
                  onClick: onGoCall
                }, "进入医生视频"))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
  ]))
}
}

})